module.exports = __webpack_public_path__ + "img/progresspoint.a2613f3a.png";